<div class="w-full">
  <div class="flex flex-col w-full chrome-audit-events-grid-container">
    <span class="section-title p-4">Captured events for the last 30 days (max 100)</span>

    <!-- Loading State -->
    <div *ngIf="isLoading" class="loading-state">
      <mat-progress-spinner
        diameter="80"
        mode="indeterminate"
        color="primary">
      </mat-progress-spinner>
      <p class="loading-text">Loading audit events...</p>
    </div>

    <!-- Grid State -->
    <lib-cdw-search-grid
      [class.hidden]="isLoading"
      [columnDefs]="columnDefs"
      [itemLabel]="itemLabel"
      [searchGridDataSource]="'sql'"
      [filterBarSettings]="filterBarSettings"
      [cdwSearchGridDataService]="chromeAuditEventsDataService"
      [componentId]="componentId"
      (dataLoaded)="onDataLoaded()"
      [filterBySelectedColumnName]="'id'"
      [useMatIcon]="true"
      [customTextColor]="gray300"
      [customHeaderTextColor]="gray300"
      customHeaderFontWeight="700"
      customHeaderFontSize="14px"
      customRowFontSize="14px"
      customRowFontWeight="400"
      [headerBgColor]="gray50"
      [footerBgColor]="gray50"
      [rowHeight]="36"
      fontFamily="Roboto"
    ></lib-cdw-search-grid>

    <!--
      TEMPORARY: Chrome Audit Events hidden behind "Coming soon..." overlay
      TO ENABLE: Change htmlContent from 'Coming soon...' to 'No audit events found'
      Also see chrome-audit-events.component.ts for additional changes needed
    -->
    <lib-cdw-empty-state-overlay
      *ngIf="showEmptyState"
      [illustrationType]="'illustration-2'"
      [htmlContent]="'Coming soon...'"
    ></lib-cdw-empty-state-overlay>
  </div>
</div>
